(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8549],{

/***/ 59193:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/permission-check",
      function () {
        return __webpack_require__(93025);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ getCode; },
/* harmony export */   "DF": function() { return /* binding */ androidLocalRefresh; },
/* harmony export */   "LW": function() { return /* binding */ localShooting; },
/* harmony export */   "UC": function() { return /* binding */ localPhoneSendEmailios; },
/* harmony export */   "ds": function() { return /* binding */ CheckCode; },
/* harmony export */   "gM": function() { return /* binding */ checkAppLastVersion; },
/* harmony export */   "lm": function() { return /* binding */ localPhoneSendEmailandroid; },
/* harmony export */   "sk": function() { return /* binding */ setBlock; },
/* harmony export */   "zW": function() { return /* binding */ androidLocalRecordQuestionRrecycleGet; }
/* harmony export */ });
/* unused harmony exports localPhoneSendEmail, androidLocalAsyncDataStatus */
/* harmony import */ var _src_utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93103);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);


//apk注册码
const getCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/user/get-device-code", options);
//apk验证注册码是否绑定
const CheckCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/user/check-device-code", options);
// 判断本地app是否最新版本
const checkAppLastVersion = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/get-app/version?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
// 本地app请求刷新
const androidLocalRefresh = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-reset-data", options);
// 本地app录制状态获取
const androidLocalRecordQuestionRrecycleGet = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/device/android-local-record-question-recycle-get?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
//AndRoid-Local选择moto机型时发送邮件
const localPhoneSendEmail = (options)=>axios.post("/api/definition/target-phone", options);
const localPhoneSendEmailios = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-ios-phone", options);
const localPhoneSendEmailandroid = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-android-phone", options);
//Block app && Block wifi获取应用解锁状态
const setBlock = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-device-type-limit", options);
//take photos && record video轮训消息
const localShooting = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/a-local-shooting-log", {
        params: options
    });
// apk同步下载数据轮询状态
const androidLocalAsyncDataStatus = (options)=>axios.post("/api/device/android-local-async-data-status", options);


/***/ }),

/***/ 82017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useDeviceScopedInit; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34745);



/**

 * 当前选中设备变化时重新执行初始化逻辑（拉数、重置本地 state 等）。

 * 通过 requestKey 与 AbortSignal 丢弃切换前未完成的异步请求。

 *

 * @param {(deviceUser: string, scope: {

 *   context: Object,

 *   signal: AbortSignal,

 *   isCurrent: () => boolean

 * }) => void} initFn - 设备作用域初始化回调，需 useCallback 包裹

 */ function useDeviceScopedInit(initFn) {
    const deviceUser = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((state)=>state.Common.deviceUser);
    const context = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceContext */ .VQ);
    const requestKey = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceRequestKey */ .rx);
    const contextRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(context);
    contextRef.current = context;
    const effectiveDeviceUser = deviceUser || (context === null || context === void 0 ? void 0 : context.accountId) || (context === null || context === void 0 ? void 0 : context.username);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!effectiveDeviceUser) return;
        const controller = new AbortController();
        let active = true;
        const scopedContext = contextRef.current;
        // 仅当 requestKey 仍与当前 Redux 一致时，才应用异步结果
        const isCurrent = ()=>{
            var ref;
            return active && !controller.signal.aborted && ((ref = contextRef.current) === null || ref === void 0 ? void 0 : ref.requestKey) === requestKey;
        };
        initFn(effectiveDeviceUser, {
            context: scopedContext,
            signal: controller.signal,
            isCurrent
        });
        return ()=>{
            active = false;
            controller.abort();
        };
    }, [
        effectiveDeviceUser,
        initFn,
        requestKey
    ]);
}


/***/ }),

/***/ 93025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ permission_check; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/i18n.js + 1 modules
var i18n = __webpack_require__(61906);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/components/motion/proxy.mjs + 241 modules
var proxy = __webpack_require__(50607);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableRow/TableRow.js + 2 modules
var TableRow = __webpack_require__(3376);
// EXTERNAL MODULE: ./node_modules/antd/es/switch/index.js + 2 modules
var es_switch = __webpack_require__(72269);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/store/apps/Common/index.js
var Common = __webpack_require__(34745);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/utils/permissionTemplate.js


/** 根据 t / locale 构建权限项模板（无后端 status）
 * @param {Function} t - i18n 翻译函数
 * @param {string} locale - 当前语言
 * @param {React.ReactNode} gt - 大于号展示节点
 * @returns {Array}
 */ function buildPermissionTemplate(t, locale, gt) {
    return [
        {
            purview: t("Accessibility"),
            data: "ACCESSIBILITY",
            pc: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        class: "font-bold",
                        children: "1.Samsung/Motor/Other Android:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.1."
                                    }),
                                    " ",
                                    t("Go to"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Settings")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.2."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Accessibility")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/accessibility.svg",
                                alt: "Accessibility"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "1.3."
                                }),
                                " ",
                                t("Click"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: t("Installed apps")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.4."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Update Service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.5."
                                    }),
                                    " ",
                                    t("Make sure it’s"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("on")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "2. ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                class: "font-bold",
                                children: "Xiaomi:"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.1."
                                    }),
                                    " ",
                                    t("Go to"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Settings")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "2.2."
                                }),
                                " ",
                                t("Additional settings")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.3."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Accessibility")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/accessibility.svg",
                                alt: "Accessibility"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "2.4."
                                }),
                                " ",
                                t("Downloaded apps")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.5."
                                    }),
                                    "  ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Update Service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.6."
                                    }),
                                    " ",
                                    t("Make sure its"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("on")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: "mr-1",
                                src: "/images/android/permission/accessibility-ps.svg",
                                width: 16,
                                height: 16,
                                alt: "ps"
                            }),
                            " ",
                            t("Notice")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                style: {
                                    whiteSpace: "pre-wrap",
                                    color: "#2E3D4C",
                                    marginTop: "4px"
                                },
                                children: t("If there are restrictions when enabling permissions")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                style: {
                                    whiteSpace: "pre-wrap",
                                    color: "#2E3D4C",
                                    marginTop: "4px"
                                },
                                children: [
                                    "1. ",
                                    t("Please select"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        style: {
                                            fontWeight: "600"
                                        },
                                        children: [
                                            t("Update service"),
                                            " "
                                        ]
                                    }),
                                    " ",
                                    t("application in"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            fontWeight: "600"
                                        },
                                        children: t("Settings")
                                    }),
                                    " ",
                                    ">",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        style: {
                                            fontWeight: "600"
                                        },
                                        children: [
                                            " ",
                                            t("Applications")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                style: {
                                    whiteSpace: "pre-wrap",
                                    color: "#2E3D4C",
                                    marginTop: "4px"
                                },
                                children: [
                                    "2.",
                                    t("Restricted settings are allowed in the more options of the sequence otherwise this setting cannot be changed")
                                ]
                            })
                        ]
                    })
                ]
            }),
            mobile: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-wrap items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-bold",
                        children: "1.Samsung/Motor/Other Android:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center mb-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: "inline-block mx-[6px]",
                                width: 20,
                                height: 20,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                children: [
                                    t("Settings"),
                                    " ",
                                    gt
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center mb-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: "inline-block mx-[6px]",
                                width: 20,
                                height: 20,
                                src: "/images/android/permission/accessibility.svg",
                                alt: "Accessibility"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                children: [
                                    t("Accessibility"),
                                    " ",
                                    gt
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center mb-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                            children: [
                                "(",
                                t("Installed apps"),
                                ") ",
                                gt
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center mb-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: "inline-block mx-[6px]",
                                width: 20,
                                height: 20,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                children: [
                                    t("Update Service"),
                                    " ",
                                    gt
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center mb-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: "inline-block leading-[21px] mr-[6px]",
                                width: 27,
                                height: 16,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                children: t("Make sure its on")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "2. ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-bold",
                                        children: "Xiaomi:"
                                    }),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-wrap",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center mb-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                className: "inline-block mx-[6px]",
                                                width: 20,
                                                height: 20,
                                                src: "/images/android/permission/setting.svg",
                                                alt: "setting"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                                children: [
                                                    t("Settings"),
                                                    " ",
                                                    gt
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center mb-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                            children: [
                                                t("Additional settings"),
                                                " ",
                                                gt
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center mb-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                            children: [
                                                t("Acceseibility"),
                                                " ",
                                                gt
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center mb-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                            children: [
                                                t("Downloaded apps"),
                                                " ",
                                                gt
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center mb-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                            children: [
                                                t("Upadate service"),
                                                " ",
                                                gt
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center mb-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                className: "inline-block leading-[21px] mr-[6px]",
                                                width: 27,
                                                height: 16,
                                                src: "/images/android/permission/switch.svg",
                                                alt: "switch"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                                children: t("Make sure its on")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "mr-1",
                                        src: "/images/android/permission/accessibility-ps.svg",
                                        width: 16,
                                        height: 16,
                                        alt: "ps"
                                    }),
                                    " ",
                                    t("Notice")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                style: {
                                    whiteSpace: "pre-wrap",
                                    color: "#2E3D4C",
                                    marginTop: "4px"
                                },
                                children: t("If there are restrictions when enabling permissions")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                style: {
                                    whiteSpace: "pre-wrap",
                                    color: "#2E3D4C",
                                    marginTop: "4px"
                                },
                                children: [
                                    "1. ",
                                    t("Settings"),
                                    " ",
                                    ">",
                                    " ",
                                    t("Apps"),
                                    " ",
                                    ">",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        style: {
                                            fontWeight: "600"
                                        },
                                        children: [
                                            t("Update service"),
                                            " "
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                style: {
                                    whiteSpace: "pre-wrap",
                                    color: "#2E3D4C",
                                    marginTop: "4px"
                                },
                                children: [
                                    "2. ",
                                    t("Tap on the 3 dots in the upper right corner")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                style: {
                                    whiteSpace: "pre-wrap",
                                    color: "#2E3D4C",
                                    marginTop: "4px"
                                },
                                children: [
                                    "3. ",
                                    t("Tap"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            fontWeight: "600"
                                        },
                                        children: t("Allow restricted settings")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        },
        {
            purview: t("Camera"),
            data: "CAMERA",
            pc: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        class: "font-bold",
                        children: "1.Samsung/Motor/Other Android"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.1"
                                    }),
                                    " ",
                                    t("Go to"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Settings")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.2."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Apps")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/app.svg",
                                alt: "app"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.3."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Update Service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.4."
                                    }),
                                    " ",
                                    t("Click"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Camera")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/camera.svg",
                                alt: "camera"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.5."
                                    }),
                                    " ",
                                    t("Make sure its"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("on")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        class: "font-bold",
                        children: "2.Xiaomi:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.1."
                                    }),
                                    " ",
                                    t("Go to"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Settings")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.2."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Apps")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/app.svg",
                                alt: "app"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "2.3."
                                }),
                                " ",
                                t("Manage apps")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.4."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Update Service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "2.5."
                                }),
                                "  ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: t("App permissions")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.6."
                                    }),
                                    " ",
                                    t("Click"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Camera")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/camera.svg",
                                alt: "camera"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.7. "
                                    }),
                                    " ",
                                    t("Allow only while using the app"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("on")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            })
                        ]
                    })
                ]
            }),
            mobile: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "font-bold",
                                children: "1.Samsung/Motor/Other Android"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/setting.svg",
                                        alt: "setting"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Settings"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/app.svg",
                                        alt: "app"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Apps"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/service.svg",
                                        alt: "service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Update Service"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Permissions"),
                                            " ",
                                            gt
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/camera.svg",
                                        alt: "camera"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Camera"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 27,
                                        height: 16,
                                        src: "/images/android/permission/switch.svg",
                                        alt: "switch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Make sure it’s on"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-bold",
                        children: "2.Xiaomi: "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/setting.svg",
                                        alt: "setting"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Settings"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/app.svg",
                                        alt: "app"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Apps"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Manage apps"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/service.svg",
                                        alt: "service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Update Service"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("App permissions"),
                                            " ",
                                            gt
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/camera.svg",
                                        alt: "camera"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Camera"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 27,
                                        height: 16,
                                        src: "/images/android/permission/switch.svg",
                                        alt: "switch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Allow only while using the app"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        },
        {
            purview: t("Location"),
            data: "SYSTEM_LOCATION",
            pc: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "1.\xa0 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: t("Pull down")
                            }),
                            " ",
                            t("the notification panel")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "whitespace-normal break-normal",
                        children: [
                            "2. ",
                            t("In the Quick panel tap the"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: t("Location icon")
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-3",
                        children: t("Or you can")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "1.\xa0 ",
                            t("Go to"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: t("Settings")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "2. ",
                            t("Select"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: t("Location")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "3. ",
                            t("Make sure its"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: t("On")
                            })
                        ]
                    })
                ]
            }),
            mobile: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "1.\xa0 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: t("Pull down")
                            }),
                            " ",
                            t("the notification panel")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "whitespace-normal",
                        children: [
                            "2. ",
                            t("In the Quick panel tap the"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: t("Location icon")
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-3",
                        children: t("Or you can")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "1.\xa0 ",
                            t("Go to"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: t("Settings")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "2. ",
                            t("Select"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: t("Location")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "3. ",
                            t("Make sure its"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: t("On")
                            })
                        ]
                    })
                ]
            })
        },
        {
            purview: t("Location access"),
            data: "LOCATION",
            pc: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-bold",
                        children: "1.Samsung/Motor/Other Android:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.1"
                                    }),
                                    " ",
                                    t("Go to"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Settings")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.2."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Apps")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/app.svg",
                                alt: "app"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.3."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Update Service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "1.4."
                                }),
                                " ",
                                t("Find"),
                                " ",
                                t("Permissions")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.5."
                                    }),
                                    " ",
                                    t("Click"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                        children: [
                                            t("Locations"),
                                            " "
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/location.svg",
                                alt: "location"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.6."
                                    }),
                                    " ",
                                    t("Make sure it’s"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("on")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-bold",
                        children: "2.Xiaomi:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.1."
                                    }),
                                    " ",
                                    t("Go to"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Settings")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.2"
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Apps")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/app.svg",
                                alt: "app"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "2.3."
                                }),
                                " ",
                                t("Manage apps")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.4."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Update Service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "2.5."
                                }),
                                " ",
                                t("Find"),
                                " ",
                                t("App Permissions")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.6."
                                    }),
                                    " ",
                                    t("Click"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                        children: [
                                            t("Locations"),
                                            " "
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/location.svg",
                                alt: "location"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.7."
                                    }),
                                    " ",
                                    t("Allow all the time")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            })
                        ]
                    })
                ]
            }),
            mobile: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-bold",
                        children: "Samsung/Motor/Other Android:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/setting.svg",
                                        alt: "setting"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Settings"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/app.svg",
                                        alt: "app"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Apps"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/service.svg",
                                        alt: "service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Update Service"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Permissions"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/location.svg",
                                        alt: "location"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Locations"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 27,
                                        height: 16,
                                        src: "/images/android/permission/switch.svg",
                                        alt: "switch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Make sure its on"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-bold",
                        children: "Xiaomi:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/setting.svg",
                                        alt: "setting"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Settings"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/app.svg",
                                        alt: "app"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Apps"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Manage apps"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/service.svg",
                                        alt: "service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Update Service"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("App Permissions"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/location.svg",
                                        alt: "location"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Locations"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 27,
                                        height: 16,
                                        src: "/images/android/permission/switch.svg",
                                        alt: "switch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Allow all the time"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        },
        {
            purview: t("SMS"),
            data: "SMS",
            pc: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-bold",
                        children: "1.Samsung/Motor/Other Android:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.1."
                                    }),
                                    " ",
                                    t("Go to"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Settings")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.2."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Apps")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/app.svg",
                                alt: "app"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.3."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Update Service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "1.4."
                                }),
                                " ",
                                t("Find"),
                                " ",
                                t("Permissions")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.5."
                                    }),
                                    " ",
                                    t("Click"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                        children: [
                                            t("SMS"),
                                            " "
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/sms.svg",
                                alt: "SMS"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.6."
                                    }),
                                    " ",
                                    t("Make sure it’s"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("on")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-bold",
                        children: "2.Xiaomi:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.1."
                                    }),
                                    " ",
                                    t("Go to"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Settings")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.2."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Apps")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/app.svg",
                                alt: "app"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.3."
                                    }),
                                    " ",
                                    t("Manage apps")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/app.svg",
                                alt: "app"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.4."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Update Service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "2.5."
                                }),
                                " ",
                                t("Find"),
                                " ",
                                t("App Permissions")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.6."
                                    }),
                                    " ",
                                    t("Click"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                        children: [
                                            t("SMS"),
                                            " "
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/sms.svg",
                                alt: "SMS"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.7."
                                    }),
                                    " ",
                                    t("Allow")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            })
                        ]
                    })
                ]
            }),
            mobile: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        class: "font-bold",
                        children: "Samsung/Motor/Other Android:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/setting.svg",
                                        alt: "setting"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Settings"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/app.svg",
                                        alt: "app"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Apps"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/service.svg",
                                        alt: "service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Update Service"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Permissions"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/sms.svg",
                                        alt: "SMS"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("SMS"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 27,
                                        height: 16,
                                        src: "/images/android/permission/switch.svg",
                                        alt: "switch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Make sure its on"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        class: "font-bold",
                        children: "Xiaomi:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/setting.svg",
                                        alt: "setting"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Settings"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/app.svg",
                                        alt: "app"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Apps"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Manage apps"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/service.svg",
                                        alt: "service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Update Service"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("App Permissions"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/sms.svg",
                                        alt: "SMS"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("SMS"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 27,
                                        height: 16,
                                        src: "/images/android/permission/switch.svg",
                                        alt: "switch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Allow"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        },
        {
            purview: t("Call log"),
            data: "CALL_LOG",
            pc: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-bold",
                        children: "1.Samsung/Motor/Other Android:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.1."
                                    }),
                                    " ",
                                    t("Go to"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Settings")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.2."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Apps")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/app.svg",
                                alt: "app"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.3."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Update Service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "1.4."
                                }),
                                " ",
                                t("Find"),
                                " ",
                                t("Permissions")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.5."
                                    }),
                                    " ",
                                    t("Click"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                        children: [
                                            t("Call logs"),
                                            " "
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/call-log.svg",
                                alt: "call log"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.6."
                                    }),
                                    " ",
                                    t("Make sure it’s"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("on")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-bold",
                        children: "2.Xiaomi:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.1."
                                    }),
                                    " ",
                                    t("Go to"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Settings")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.2."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Apps")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/app.svg",
                                alt: "app"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "2.3."
                                }),
                                " ",
                                t("Manage apps")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.4."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Update Service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "2.5."
                                }),
                                " ",
                                t("Find"),
                                " ",
                                t("App Permissions")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.6."
                                    }),
                                    " ",
                                    t("Allow all the time")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            })
                        ]
                    })
                ]
            }),
            mobile: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "font-bold",
                                children: "Samsung/Motor/Other Android:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/setting.svg",
                                        alt: "setting"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Settings"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/app.svg",
                                        alt: "app"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Apps"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/service.svg",
                                        alt: "service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Update Service"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Permissions"),
                                            " ",
                                            gt
                                        ]
                                    }),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/call-log.svg",
                                        alt: "call log"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Call logs"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 27,
                                        height: 16,
                                        src: "/images/android/permission/switch.svg",
                                        alt: "switch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Make sure its on"),
                                            " ",
                                            gt
                                        ]
                                    }),
                                    " "
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-bold",
                        children: "Xiaomi"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/setting.svg",
                                        alt: "setting"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Settings"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/app.svg",
                                        alt: "app"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Apps"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Manage apps"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/service.svg",
                                        alt: "service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Update Service"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("App Permissions"),
                                            " ",
                                            gt
                                        ]
                                    }),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Location"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 27,
                                        height: 16,
                                        src: "/images/android/permission/switch.svg",
                                        alt: "switch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Allow all the time"),
                                            " ",
                                            gt
                                        ]
                                    }),
                                    " "
                                ]
                            })
                        ]
                    })
                ]
            })
        },
        {
            purview: t("Photos and videos"),
            data: "PHOTO_LIBRARY",
            pc: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        class: "font-bold",
                        children: "1.Samsung/Motor/Other Android:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.1."
                                    }),
                                    " ",
                                    t("Go to"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Settings")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.2."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Apps")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/app.svg",
                                alt: "app"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.3."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Update Service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "1.4."
                                }),
                                " ",
                                t("Find"),
                                " ",
                                t("Permissions")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.5."
                                    }),
                                    " ",
                                    t("Click"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                        children: [
                                            t("Photos and videos"),
                                            " "
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/camera.svg",
                                alt: "camera"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.6."
                                    }),
                                    " ",
                                    t("Make sure it’s"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("on")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        class: "font-bold",
                        children: "2.Xiaomi:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.1."
                                    }),
                                    " ",
                                    t("Go to"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Settings")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.2."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Apps")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/app.svg",
                                alt: "app"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "2.3."
                                }),
                                " ",
                                t("Find"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: t("Manage apps")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.4."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Update Service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "2.5."
                                }),
                                " ",
                                t("Find"),
                                " ",
                                t("App Permissions")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.6."
                                    }),
                                    " ",
                                    t("Click"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                        children: [
                                            t("Photos and videos"),
                                            " "
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/camera.svg",
                                alt: "camera"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.7."
                                    }),
                                    " ",
                                    t("Allow")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            })
                        ]
                    })
                ]
            }),
            mobile: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "font-bold",
                                children: "1.Samsung/Motor/Other Android:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/setting.svg",
                                        alt: "setting"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Settings"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/app.svg",
                                        alt: "app"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Apps"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/service.svg",
                                        alt: "service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Update Service"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Permissions"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/camera.svg",
                                        alt: "camera"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Photos and videos"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 27,
                                        height: 16,
                                        src: "/images/android/permission/switch.svg",
                                        alt: "switch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Make sure its on"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-bold",
                        children: "2.Xiaomi:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/setting.svg",
                                        alt: "setting"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Settings"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/app.svg",
                                        alt: "app"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Apps"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Manage apps"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/service.svg",
                                        alt: "service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Update Service"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("App permissions"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/camera.svg",
                                        alt: "camera"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Photos and videos"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 27,
                                        height: 16,
                                        src: "/images/android/permission/switch.svg",
                                        alt: "switch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Allow"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        },
        {
            purview: t("Microphone"),
            data: "MICROPHONE",
            pc: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        class: "font-bold",
                        children: "1.Samsung/Motor/Other Android"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.1."
                                    }),
                                    " ",
                                    t("Go to"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Settings")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.2."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Apps")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/app.svg",
                                alt: "app"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.3."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Update Service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "1.4."
                                }),
                                " ",
                                t("Find"),
                                " ",
                                t("Permissions")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.5."
                                    }),
                                    " ",
                                    t("Click"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                        children: [
                                            t("Microphone"),
                                            " "
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/microphone.svg",
                                alt: "Microphone"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.6."
                                    }),
                                    " ",
                                    t("Make sure its"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("on")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        class: "font-bold",
                        children: "2.Xiaomi:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.1."
                                    }),
                                    " ",
                                    t("Go to"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Settings")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.2."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Apps")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/app.svg",
                                alt: "app"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.3."
                                    }),
                                    " ",
                                    t("Manage apps")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/app.svg",
                                alt: "app"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.4."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Update Service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "2.5."
                                }),
                                " ",
                                t("App"),
                                " ",
                                t("Permissions")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.6."
                                    }),
                                    " ",
                                    t("Click"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                        children: [
                                            t("Microphone"),
                                            " "
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/microphone.svg",
                                alt: "Microphone"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.7."
                                    }),
                                    " ",
                                    t("Allow only while using the app")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            })
                        ]
                    })
                ]
            }),
            mobile: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "font-bold",
                                children: "1.Samsung/Motor/Other Android"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/setting.svg",
                                        alt: "setting"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Settings"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/app.svg",
                                        alt: "app"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Apps"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/service.svg",
                                        alt: "service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Update Service"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Permissions"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/microphone.svg",
                                        alt: "Microphone"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Microphone"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 27,
                                        height: 16,
                                        src: "/images/android/permission/switch.svg",
                                        alt: "switch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Make sure its on"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-bold",
                        children: "2.Xiaomi:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/setting.svg",
                                        alt: "setting"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Settings"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/app.svg",
                                        alt: "app"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Apps"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Manage apps"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/service.svg",
                                        alt: "service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Update Service"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("App permissions"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/microphone.svg",
                                        alt: "Microphone"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Microphone"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("App permission"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 27,
                                        height: 16,
                                        src: "/images/android/permission/switch.svg",
                                        alt: "switch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Allow only while using the app"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        },
        {
            purview: t("Contact"),
            data: "CONTACT",
            pc: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        class: "font-bold",
                        children: "1.Samsung/Motor/Other Android: "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.1."
                                    }),
                                    " ",
                                    t("Go to"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Settings")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.2."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Apps")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/app.svg",
                                alt: "app"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.3."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Update Service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "1.4."
                                }),
                                " ",
                                t("Find"),
                                " ",
                                t("Permissions")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.5."
                                    }),
                                    " ",
                                    t("Click"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                        children: [
                                            t("Contact"),
                                            " "
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/contacts.svg",
                                alt: "Contact"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.6."
                                    }),
                                    " ",
                                    t("Make sure it’s"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("on")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        class: "font-bold",
                        children: "2.Xiaomi：  "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.1."
                                    }),
                                    " ",
                                    t("Go to"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Settings")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.2."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Apps")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/app.svg",
                                alt: "app"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.3."
                                    }),
                                    " ",
                                    t("Manage apps")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/app.svg",
                                alt: "app"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.4."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Update Service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "2.5."
                                }),
                                " ",
                                t("App"),
                                " ",
                                t("Permissions")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.6."
                                    }),
                                    " ",
                                    t("Click"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                        children: [
                                            t("Contact"),
                                            " "
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/contacts.svg",
                                alt: "Contact"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.7."
                                    }),
                                    " ",
                                    t("Allow")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            })
                        ]
                    })
                ]
            }),
            mobile: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "font-bold",
                                children: "1.Samsung/Motor/Other Android: "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/setting.svg",
                                        alt: "setting"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Settings"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/app.svg",
                                        alt: "app"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Apps"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/service.svg",
                                        alt: "service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Update Service"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Permissions"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/contacts.svg",
                                        alt: "Contact"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Contact"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 27,
                                        height: 16,
                                        src: "/images/android/permission/switch.svg",
                                        alt: "switch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Make sure its on"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-bold",
                        children: "2.Xiaomi： "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/setting.svg",
                                        alt: "setting"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Settings"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/app.svg",
                                        alt: "app"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Apps"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Manage apps"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/service.svg",
                                        alt: "service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Update Service"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("App permissions"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/contacts.svg",
                                        alt: "Contact"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Contact"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 27,
                                        height: 16,
                                        src: "/images/android/permission/switch.svg",
                                        alt: "switch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Allow"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        },
        {
            purview: t("Calendar"),
            data: "CALENDAR",
            pc: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        class: "font-bold",
                        children: "1.Samsung/Motor/Other Android"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.1."
                                    }),
                                    " ",
                                    t("Go to"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Settings")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.2."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Apps")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/app.svg",
                                alt: "app"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.3."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Update Service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "1.4."
                                }),
                                " ",
                                t("Find"),
                                " ",
                                t("Permissions")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.5."
                                    }),
                                    " ",
                                    t("Click"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                        children: [
                                            t("Calendar"),
                                            " "
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/calendar.svg",
                                alt: "calendar"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.6."
                                    }),
                                    " ",
                                    t("Make sure its"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("on")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        class: "font-bold",
                        children: "2.Xiaomi:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.1."
                                    }),
                                    " ",
                                    t("Go to"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Settings")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.2."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Apps")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/app.svg",
                                alt: "app"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "2.3."
                                }),
                                " ",
                                t("Manage apps")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.4."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Update Service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "2.5."
                                }),
                                " ",
                                t("App"),
                                " ",
                                t("Permissions")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.6."
                                    }),
                                    " ",
                                    t("Click"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                        children: [
                                            t("Calendar"),
                                            " "
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/calendar.svg",
                                alt: "calendar"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.7."
                                    }),
                                    " ",
                                    t("Allow")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            })
                        ]
                    })
                ]
            }),
            mobile: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "font-bold",
                                children: "1.Samsung/Motor/Other Android"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/setting.svg",
                                        alt: "setting"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Settings"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/app.svg",
                                        alt: "app"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Apps"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/service.svg",
                                        alt: "service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Update Service"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Permissions"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/calendar.svg",
                                        alt: "calendar"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Calendar"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 27,
                                        height: 16,
                                        src: "/images/android/permission/switch.svg",
                                        alt: "switch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Make sure its on"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-bold",
                        children: "2.Xiaomi:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/setting.svg",
                                        alt: "setting"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Settings"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/app.svg",
                                        alt: "app"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Apps"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/app.svg",
                                        alt: "app"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Manage apps"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/service.svg",
                                        alt: "service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Update Service"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("App permissions"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/calendar.svg",
                                        alt: "calendar"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Calendar"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 27,
                                        height: 16,
                                        src: "/images/android/permission/switch.svg",
                                        alt: "switch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Allow"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        },
        {
            purview: t("Priority"),
            data: "PRIORITY",
            pc: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        class: "font-bold",
                        children: "1.Samsung/Motor/Other "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.1."
                                    }),
                                    " ",
                                    t("Go to"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Settings")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "1.2."
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                    children: [
                                        "(" + t("Display over other"),
                                        " ",
                                        t("Apps") + ")",
                                        " ",
                                        t("either")
                                    ]
                                }),
                                " ",
                                "/ ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: t("Appear on top")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.3."
                                    }),
                                    " ",
                                    t("Update"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1.4."
                                    }),
                                    " ",
                                    t("Make sure its"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("on")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        class: "font-bold",
                        children: "2.Xiaomi: "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.1."
                                    }),
                                    " ",
                                    t("Go to"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Settings")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "2.2."
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: t("Privacy protection")
                                }),
                                " "
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "2.3."
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: t("Special permissions")
                                }),
                                " "
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "2.4."
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: t("Display over other apps")
                                }),
                                " "
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.5."
                                    }),
                                    " ",
                                    t("Update"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "2.6."
                                    }),
                                    " ",
                                    t("Make sure its on")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            })
                        ]
                    })
                ]
            }),
            mobile: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-bold",
                        children: "1.Samsung/Motor/Other "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/setting.svg",
                                        alt: "setting"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Settings"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        "(" + t("Display over other"),
                                        " ",
                                        t("Apps") + ")",
                                        " ",
                                        t("either"),
                                        " / ",
                                        t("Appear on top"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/service.svg",
                                        alt: "service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Update Service"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 27,
                                        height: 16,
                                        src: "/images/android/permission/switch.svg",
                                        alt: "switch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Make sure its on"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-bold",
                        children: "2.Xiaomi: "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "inline-block mx-[6px]",
                                        width: 20,
                                        height: 20,
                                        src: "/images/android/permission/setting.svg",
                                        alt: "setting"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                        children: [
                                            t("Settings"),
                                            " ",
                                            gt
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Privacy protection"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Special permissions"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Display over other apps"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Update service"),
                                        " ",
                                        gt
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Make sure its on"),
                                        " ",
                                        gt
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        },
        {
            purview: t("Screenshot"),
            data: "SCREENSHOT",
            pc: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "whitespace-normal break-normal py-2 leading-[28px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "1."
                                }),
                                " ",
                                t("On the target phones browser type"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    className: "bg-[#87C5FF] rounded-[10px] mx-1 px-[8px] py-[2px] whitespace-normal inline-block",
                                    children: "https://test-ms-dashboard.gbyte.com.cn"
                                }),
                                " ",
                                t("into the address bar and go to the download page"),
                                "."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "whitespace-normal break-normal py-2 leading-[28px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "2."
                                }),
                                " ",
                                t("Install and open"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    className: "bg-[#87C5FF] rounded-[10px] mx-1 px-[8px] py-[2px] whitespace-nowrap inline-block",
                                    children: t("Msafely Installer")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "whitespace-normal break-normal py-2 leading-[28px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "3."
                                }),
                                " ",
                                t("Tap"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    className: "bg-[#87C5FF] rounded-[10px] mx-1 px-[8px] py-[2px] whitespace-normal inline-block",
                                    children: t("Lets Start")
                                }),
                                " ",
                                t("on the welcome page. This will automatically grant screenshot permissions"),
                                "."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "whitespace-normal break-normal py-2 leading-[28px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "4."
                                }),
                                " ",
                                t("Now you can"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    className: "bg-[#87C5FF] rounded-[10px] mx-1 px-[8px] py-[2px] whitespace-normal inline-block",
                                    children: t("uninstall")
                                }),
                                " ",
                                t("the Msafely Installer"),
                                "."
                            ]
                        })
                    })
                ]
            }),
            mobile: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "whitespace-normal break-normal py-2 leading-[28px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "1."
                                }),
                                " ",
                                t("On the target phones browser type"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    className: "bg-[#87C5FF] rounded-[10px] mx-1 px-[8px] py-[2px] whitespace-normal inline-block",
                                    children: "https://test-ms-dashboard.gbyte.com.cn"
                                }),
                                " ",
                                t("into the address bar and go to the download page"),
                                "."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "whitespace-normal break-normal py-2 leading-[28px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "2."
                                }),
                                " ",
                                t("Install and open"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    className: "bg-[#87C5FF] rounded-[10px] mx-1 px-[8px] py-[2px] whitespace-nowrap inline-block",
                                    children: t("Msafely Installer")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "whitespace-normal break-normal py-2 leading-[28px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "3."
                                }),
                                " ",
                                t("Tap"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    className: "bg-[#87C5FF] rounded-[10px] mx-1 px-[8px] py-[2px] whitespace-normal inline-block",
                                    children: t("Lets Start")
                                }),
                                " ",
                                t("on the welcome page. This will automatically grant screenshot permissions"),
                                "."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "whitespace-normal break-normal py-2 leading-[28px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "4."
                                }),
                                " ",
                                t("Now you can"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    className: "bg-[#87C5FF] rounded-[10px] mx-1 px-[8px] py-[2px] whitespace-normal inline-block",
                                    children: t("uninstall")
                                }),
                                " ",
                                t("the Msafely Installer"),
                                "."
                            ]
                        })
                    })
                ]
            })
        },
        {
            purview: t("Notice"),
            data: "NOTICE",
            pc: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1."
                                    }),
                                    " ",
                                    t("Go to"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Settings")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "2."
                                }),
                                " ",
                                t("Search for"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: t("device and application notifications")
                                }),
                                " or",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: t("notification usage rights")
                                }),
                                " or",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: t("notification access")
                                }),
                                " ",
                                t("in the search box")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "3."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Update Service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "4."
                                    }),
                                    " ",
                                    t("Make sure its on")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            })
                        ]
                    })
                ]
            }),
            mobile: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-wrap items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center mb-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    className: "inline-block mx-[6px]",
                                    width: 20,
                                    height: 20,
                                    src: "/images/android/permission/setting.svg",
                                    alt: "setting"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Settings"),
                                        " ",
                                        gt
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center mb-2 px-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                children: [
                                    t("Search for"),
                                    " ",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("device and application notifications")
                                    }),
                                    " or",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("notification usage rights")
                                    }),
                                    " or",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("notification access")
                                    }),
                                    " ",
                                    t("in the search box"),
                                    " ",
                                    gt
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center mb-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    className: "inline-block mx-[6px]",
                                    width: 20,
                                    height: 20,
                                    src: "/images/android/permission/service.svg",
                                    alt: "service"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Update Service"),
                                        " ",
                                        gt
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center mb-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    className: "inline-block mx-[6px]",
                                    width: 27,
                                    height: 16,
                                    src: "/images/android/permission/switch.svg",
                                    alt: "switch"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Make sure its on"),
                                        " ",
                                        gt
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        },
        {
            purview: t("Usage data"),
            data: "USAGE_DATA",
            pc: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "1."
                                    }),
                                    " ",
                                    t("Go to"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Settings")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/setting.svg",
                                alt: "setting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "2."
                                }),
                                " ",
                                t("Search for"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: t("usage data access")
                                }),
                                " or",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: t("usage access permissions")
                                }),
                                " ",
                                t("in the search box")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "3."
                                    }),
                                    " ",
                                    t("Find"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("Update Service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/service.svg",
                                alt: "service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center py-[5px] whitespace-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "4."
                                    }),
                                    " ",
                                    t("Make sure its on")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 30,
                                height: 30,
                                src: "/images/android/permission/switch.svg",
                                alt: "switch"
                            })
                        ]
                    })
                ]
            }),
            mobile: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-wrap items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center mb-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    className: "inline-block mx-[6px]",
                                    width: 20,
                                    height: 20,
                                    src: "/images/android/permission/setting.svg",
                                    alt: "setting"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Settings"),
                                        " ",
                                        gt
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center mb-2 px-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                children: [
                                    t("Search for"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("usage data access")
                                    }),
                                    " or",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: t("usage access permissions")
                                    }),
                                    " ",
                                    t("in the search box"),
                                    " ",
                                    gt
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center mb-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    className: "inline-block mx-[6px]",
                                    width: 20,
                                    height: 20,
                                    src: "/images/android/permission/service.svg",
                                    alt: "service"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Update Service"),
                                        " ",
                                        gt
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center mb-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    className: "inline-block mx-[6px]",
                                    width: 27,
                                    height: 16,
                                    src: "/images/android/permission/switch.svg",
                                    alt: "switch"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "inline-block text-[16px] leading-[21px] text-[#0C6FCC]",
                                    children: [
                                        t("Make sure its on"),
                                        " ",
                                        gt
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        }
    ];
}

// EXTERNAL MODULE: ./src/@api/android.js
var android = __webpack_require__(19630);
// EXTERNAL MODULE: ./src/@api/dashboard.js
var dashboard = __webpack_require__(95629);
// EXTERNAL MODULE: ./src/hooks/useDeviceScopedInit.js
var useDeviceScopedInit = __webpack_require__(82017);
// EXTERNAL MODULE: ./src/utils/readAndroidLocalContext.js
var readAndroidLocalContext = __webpack_require__(26771);
;// CONCATENATED MODULE: ./src/hooks/usePermissionData.js





/**
 * 将接口返回的权限状态合并进静态模板，并按已开启项排序。
 * @param {Array} currentTemplate - buildPermissionTemplate 生成的模板
 * @param {Object} contents - 接口 PERMISSION_LIST contents
 * @returns {Array}
 */ const mergePermissionTemplate = (currentTemplate, contents)=>{
    const contentsArray = Object.entries(contents || {});
    const updatedStaticData = currentTemplate.map((item)=>{
        const found = contentsArray.find((param)=>{
            let [key] = param;
            return key === item.data;
        });
        if (found) {
            const [key, value] = found;
            return {
                ...item,
                permissions: key,
                status: value === 1
            };
        }
        return {
            ...item,
            status: false
        };
    });
    updatedStaticData.sort((a, b)=>(b.status === true ? 1 : 0) - (a.status === true ? 1 : 0));
    return updatedStaticData;
};
/**
 * 权限检查页数据：拉 PERMISSION_LIST、合并模板，设备切换时重拉。
 *
 * @param {Object} options
 * @param {Array} options.template - 当前 locale 的权限模板
 * @param {boolean} options.translationReady - i18n 是否就绪
 * @returns {{ staticData: Array, ischange: *, onChange: Function }}
 */ function usePermissionData(param) {
    let { template , translationReady  } = param;
    const [staticData, setStaticData] = (0,react.useState)(template);
    const [ischange, setIschange] = (0,react.useState)();
    /** 刷新设备端权限并拉取列表，支持 AbortSignal 防竞态 */ const loadPermissionData = (0,react.useCallback)(async function(deviceUdid, currentTemplate) {
        let { signal , isCurrent  } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (!deviceUdid || !(currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.length)) return;
        try {
            await (0,android/* androidLocalRefresh */.DF)({
                device_id: deviceUdid,
                type: "42"
            });
        } catch (e) {
            ;
        }
        if (isCurrent && !isCurrent()) return;
        try {
            var ref;
            const result = await (0,dashboard/* getLocalAndroidAll */.gH)({
                username: (0,readAndroidLocalContext/* readUserEmail */.t)(),
                params: {
                    category: "PERMISSION_LIST",
                    deviceUdid
                }
            }, signal ? {
                signal
            } : undefined);
            if (isCurrent && !isCurrent()) return;
            const updatedStaticData = mergePermissionTemplate(currentTemplate, result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.contents);
            setStaticData(updatedStaticData);
            const allStatusOn = updatedStaticData.every((i)=>i.status === true);
            localStorage.setItem("allStatusOn", String(allStatusOn));
            setIschange(allStatusOn ? null : 0);
        } catch (err) {
            if (isCurrent && !isCurrent() || (err === null || err === void 0 ? void 0 : err.code) === "ERR_CANCELED") return;
            ;
        }
    }, []);
    // locale 切换时同步模板结构（不触发设备切换逻辑）
    (0,react.useEffect)(()=>{
        setStaticData(template);
    }, [
        template
    ]);
    // 设备切换时重置并重新拉取权限列表
    (0,useDeviceScopedInit/* useDeviceScopedInit */.A)((0,react.useCallback)((_, param)=>{
        let { context , signal , isCurrent  } = param;
        if (!translationReady) return;
        const deviceUdid = (0,readAndroidLocalContext/* readLocalDeviceUdid */.S)(context);
        if (!deviceUdid) return;
        setStaticData(template);
        setIschange(undefined);
        loadPermissionData(deviceUdid, template, {
            signal,
            isCurrent
        });
    }, [
        translationReady,
        template,
        loadPermissionData
    ]));
    // 仅 locale / 模板变化时重拉（同设备）
    (0,react.useEffect)(()=>{
        if (!translationReady) return;
        const deviceUdid = (0,readAndroidLocalContext/* readLocalDeviceUdid */.S)();
        if (!deviceUdid) return;
        setStaticData(template);
        loadPermissionData(deviceUdid, template, {
            isCurrent: ()=>true
        });
    }, [
        translationReady,
        template,
        loadPermissionData
    ]);
    const onChange = (index)=>{
        setIschange(index);
    };
    return {
        staticData,
        ischange,
        onChange
    };
}

;// CONCATENATED MODULE: ./src/pages/android/local/permission-check/index.js










const PermissionCheck = ()=>{
    const { t , locale , isLoading  } = (0,i18n/* useTranslation */.$G)("commonAndroidLocal");
    const dispatch = (0,es/* useDispatch */.I0)();
    const gt = /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "text-black",
        children: ">"
    });
    const template = (0,react.useMemo)(()=>buildPermissionTemplate(t, locale, gt), [
        t,
        locale
    ]);
    const { staticData , ischange , onChange  } = usePermissionData({
        template,
        translationReady: !isLoading
    });
    const [isMobile, setIsMobile] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const handleResize = ()=>setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        handleResize();
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    (0,react.useEffect)(()=>{
        const permissionsMap = {
            ACCESSIBILITY: "Accessibility",
            CAMERA: "Camera",
            SYSTEM_LOCATION: "Location",
            LOCATION: "Location_Access",
            SMS: "SMS",
            CALL_LOG: "Call_Log",
            PHOTO_LIBRARY: "Photos_And_Videos",
            MICROPHONE: "Microphone",
            CONTACT: "Contact",
            CALENDAR: "Calendar",
            PRIORITY: "Priority",
            SCREENSHOT: "Screenshot",
            NOTICE: "Notice",
            USAGE_DATA: "Usage_Data"
        };
        const events = staticData.filter((item)=>{
            return (item === null || item === void 0 ? void 0 : item.status) != null;
        }).map((item)=>({
                event_name: "Click_".concat(permissionsMap[item.data], "_").concat(item.status ? "On" : "Off")
            }));
        if (events.length > 0) {}
    }, [
        staticData
    ]);
    (0,react.useEffect)(()=>{
        const title = t("Permission check");
        dispatch((0,Common/* setCurrentTab */.Lw)(title));
        return ()=>dispatch((0,Common/* setCurrentTab */.Lw)(""));
    }, [
        dispatch,
        t
    ]);
    var _ischange, _ischange1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hide-scrollbar rounded-[12px] overflow-x-auto !h-[calc(var(--vh2)*100-215px)] bg-white",
                    style: {
                        boxShadow: "0px 0px 12px 0px #0000001A"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "p-5 h-full flex w-[1200px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col w-[320px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex pb-3 justify-between ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
                                                className: "ml-4 font-semibold",
                                                children: t("Permissions")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
                                                className: "mr-4 font-semibold",
                                                children: t("Status")
                                            })
                                        ]
                                    }),
                                    staticData.map((obj, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center border-t py-[18px] justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "ml-4",
                                                    children: obj.purview
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mr-5 flex justify-center items-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "local-switch",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_switch/* default */.Z, {
                                                            style: {
                                                                backgroundColor: obj && obj.status ? "#1677FF" : "#999999"
                                                            },
                                                            size: "small",
                                                            checked: obj.status,
                                                            onChange: ()=>onChange(i)
                                                        })
                                                    })
                                                })
                                            ]
                                        }, i))
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    position: "relative"
                                },
                                className: "w-[500px] whitespace-nowrap flex flex-col popover z-40",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex pb-3 justify-center items-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "font-semibold",
                                            children: t("Setting path on the target phone")
                                        })
                                    }),
                                    staticData instanceof Array ? staticData.map((obj, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-auto justify-center relative item-center ".concat(ischange === i ? "flex" : "hidden"),
                                            style: {
                                                maxWidth: "100%",
                                                wordWrap: "break-word"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    position: "relative",
                                                    width: "70%",
                                                    top: (_ischange = [
                                                        ,
                                                        "40px",
                                                        "70px",
                                                        "120px",
                                                        "90px",
                                                        "100px",
                                                        "200px",
                                                        "260px",
                                                        "320px",
                                                        "388px",
                                                        "440px",
                                                        "470px",
                                                        "530px",
                                                        "630px"
                                                    ][ischange]) !== null && _ischange !== void 0 ? _ischange : "0px",
                                                    backgroundColor: "#fff",
                                                    borderRadius: "16px",
                                                    boxSizing: "border-box",
                                                    paddingTop: "15px",
                                                    paddingBottom: "25px",
                                                    paddingLeft: "40px",
                                                    paddingRight: "40px",
                                                    filter: "drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.1))"
                                                },
                                                children: [
                                                    obj.pc,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: {
                                                            content: '""',
                                                            position: "absolute",
                                                            left: "-29px",
                                                            top: (_ischange1 = [
                                                                ,
                                                                "40px",
                                                                "70px",
                                                                "80px",
                                                                "172px",
                                                                "223px",
                                                                "183px",
                                                                "184px",
                                                                "186px",
                                                                "180px",
                                                                "190px",
                                                                "220px",
                                                                "220px",
                                                                "180px"
                                                            ][ischange]) !== null && _ischange1 !== void 0 ? _ischange1 : "18px",
                                                            borderTop: "12px solid transparent",
                                                            borderBottom: "12px solid transparent",
                                                            borderRight: "20px solid #fff",
                                                            borderLeft: "10px solid transparent",
                                                            zIndex: "1"
                                                        }
                                                    })
                                                ]
                                            })
                                        }, i)) : null
                                ]
                            })
                        ]
                    })
                }) : null,
                isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "overflow-auto !h-[calc(var(--vh2)*100-95px)]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-white rounded-xl flex flex-col",
                        children: staticData instanceof Array ? staticData.map((row, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mx-4 ".concat(i === staticData.length - 1 ? "" : "border-b"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between ".concat(ischange === i ? "pt-[18px] pb-[12px]" : "py-[18px]"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "leading-[18px] text-[18px]",
                                                    children: row.purview
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "h-[22px] w-[2px] bg-[#D7D7D7] mr-3"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "local-switch",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_switch/* default */.Z, {
                                                            style: {
                                                                backgroundColor: row && row.status ? "#1677FF" : "#8C8C8C"
                                                            },
                                                            size: "small",
                                                            checked: row.status,
                                                            onChange: ()=>onChange(i)
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(proxy/* motion.div */.E.div, {
                                        initial: {
                                            height: 0,
                                            opacity: 0,
                                            paddingTop: 0
                                        },
                                        animate: {
                                            height: ischange === i ? "auto" : 0,
                                            opacity: ischange === i ? 1 : 0
                                        },
                                        className: "break-all leading-[30px]",
                                        children: row.mobile
                                    })
                                ]
                            }, i)) : null
                    })
                }) : null
            ]
        })
    });
};
/* harmony default export */ var permission_check = (PermissionCheck);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,607,6487,9774,2888,179], function() { return __webpack_exec__(59193); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);